import React from "react";
import { Tabs, Box } from "orcs-design-system";
import { map } from "lodash";

export const TENANT_SETTINGS_TABS = {
  BRANDING: "branding",
  GLOBAL_NOTIFICATION: "tenant-announcements",
  TENANT_FEATURE_FLAGS: "tenant-feature-flags",
  API_KEY_MANAGER: "api-key-manager",
};

const TAB_LABELS = {
  [TENANT_SETTINGS_TABS.BRANDING]: "Branding",
  [TENANT_SETTINGS_TABS.GLOBAL_NOTIFICATION]: "Tenant Announcements",
  [TENANT_SETTINGS_TABS.TENANT_FEATURE_FLAGS]: "Tenant Feature Flags",
  [TENANT_SETTINGS_TABS.API_KEY_MANAGER]: "API Key Manager",
};

export const TenantSettingsTabs = () => {
  return (
    <Box mb="r" boxBorder="default" borderTop="none" borderBottom="none">
      <Tabs
        tabsList={map(TENANT_SETTINGS_TABS, (tab) => ({
          label: TAB_LABELS[tab],
          path: tab,
        }))}
      />
    </Box>
  );
};
